"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var useQueryHook = function (query, variables) {
    var result = (0, client_1.useQuery)(query, variables && { variables: variables, notifyOnNetworkStatusChange: true });
    var data = result.data, fetchMore = result.fetchMore;
    var loading = result.loading, error = result.error;
    return {
        loading: loading,
        error: error ? error.message : '',
        data: data,
        fetchMore: fetchMore,
    };
};
exports.default = useQueryHook;
